<div class="flex flex-col gap-4" *transloco="let t">
  <p>
    {{
      t("remove-audience-popup.delete_confirm", [
        modalData.audience.expressionType,
        modalData.audience.matchType,
        modalData.audience.lookback,
      ])
    }}
  </p>
</div>
<div class="flex justify-end gap-2" *transloco="let t">
  <button iButton variant="ghost" size="md" (click)="modalRef.close()">{{ t("common.cancel") }}</button>
  <button iButton variant="destructive" size="md" (click)="delete()">{{ t("common.delete") }}</button>
</div>
